import * as EventAttendance_ from './event-attendance'
import * as FrontPage_ from './front-page'
import * as AdminEventRegistrationPage_ from './admin-event-registration-page'

export const EventAttendance = EventAttendance_
export const FrontPage = FrontPage_
export const AdminEventRegistrationPage = AdminEventRegistrationPage_



// WEBPACK FOOTER //
// ./src/events2/events2.ts